<template>
  <Dialog :modelValue="modelValue" @update:modelValue="emit('update:modelValue', $event)" @close="emit('close')" size="long">
    <div class="dialog">
      <div class="dialog-title">
        <img :src="recordDialogTitleImg" alt="recordDialogTitle">
      </div>
      <div class="dialog-content-wrap">
        <div class="record-head">
          <span>{{ t('halloween.recordReward') }}</span>
          <span>{{ t('halloween.recordTime') }}</span>
        </div>
        <div class="record-body">
          <p v-if="!records.length" class="record-empty">{{ t('halloween.empty') }}</p>
          <div v-for="(record, index) in records" :key="index" class="record-row">
            <span class="record-name">
              <template v-if="isStrikeGain(record)">
                <span>{{ taskName(record.rewardCode) }}</span>
                <span class="record-gain">
                  <img
                    class="record-pumpkin"
                    src="~@/views/act/halloween/assets/img/nangua-small.png"
                    alt=""
                  >
                  <span>+{{ record.strikeCount || 0 }}</span>
                </span>
              </template>
              <span v-else>{{ recordLabel(record) }}</span>
            </span>
            <span class="record-time">{{ formatTime(record.createTime) }}</span>
          </div>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue'
import dayjs from 'dayjs'
import { useI18n } from 'vue-i18n'
import Dialog from '../index.vue'
import RecordDialogTitleMap from '@/views/act/halloween/assets/img/recordTitle'

const emit = defineEmits(['update:modelValue', 'close'])
defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  records: {
    type: Array,
    default: () => [],
  },
})

const { t, te, locale } = useI18n()

const recordDialogTitleImg = computed(() => {
  return RecordDialogTitleMap[locale.value] || RecordDialogTitleMap.en
})

const taskName = (taskType) => {
  const key = `halloween.tasks.${taskType}`
  return te(key) ? t(key) : taskType
}

const propName = (propId) => {
  const key = `halloween.props.${propId}`
  return te(key) ? t(key) : propId
}

const rewardText = (items) => {
  if (!items?.length) return ''
  return items
    .map((item) => `${propName(item.propId)} x${item.propCount || 1}`)
    .join(',')
}

const parseSnapshot = (raw) => {
  if (!raw || raw === '[]') return []
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
    return Array.isArray(parsed) ? parsed : []
  } catch (e) {
    return []
  }
}

const isStrikeGain = (record) => record?.rewardSource === 'task'

const recordLabel = (record) => {
  if (record?.rewardSource === 'strike') {
    return `${t('halloween.strikeRecord')} x${record.strikeCount || 0}`
  }
  const snapshot = parseSnapshot(record?.propSnapshot)
  return snapshot.length ? rewardText(snapshot) : record?.rewardCode || record?.rewardSource || ''
}

const formatTime = (value) => {
  const time = Number(value)
  if (!time) return ''
  return dayjs(time).format('YYYY/M/D HH:mm')
}
</script>

<style scoped lang="less">
.dialog {
  overflow: hidden;

  .dialog-title {
    width: 424px;
    height: 77px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url('~@/views/act/halloween/assets/img/dialog-title-bg.png') no-repeat center center / 100% 100%;
    margin: 0 auto;
    margin-top: 10px;
    img {
      height: 65px;
      margin-top: 10px;
    }
  }

  .dialog-content-wrap {
    width: 608px;
    height: 650px;
    margin: 28px auto 0;
    padding: 28px 36px 24px;
    box-sizing: border-box;
    background: url('~@/views/act/halloween/assets/img/dialog-long-inner-bg.png') no-repeat center center / 100% 100%;
    display: flex;
    flex-direction: column;
  }
}

.record-head,
.record-row {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  align-items: center;
  text-align: center;
}

.record-head {
  flex: none;
  color: #fff;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 1px;
  padding-bottom: 18px;
  border-bottom: 1px solid #352670;
}

.record-body {
  flex: 1;
  overflow-y: auto;
}

.record-empty {
  margin: 40px 0 0;
  color: #fff;
  text-align: center;
  font-size: 20px;
}

.record-row {
  color: #ffe94a;
  font-size: 22px;
  font-weight: 800;
  line-height: 1.3;
  padding: 10px 0;
  // border-bottom: 1px solid #352670;
}

.record-name,
.record-time {
  padding: 0 8px;
  word-break: break-word;
}

.record-name {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.record-pumpkin {
  width: 24px;
  height: 24px;
  flex: none;
}

.record-gain {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex: none;
  white-space: nowrap;
}
</style>
